import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquotePhonePermissions extends BaseScenesPermissions {}

export default MultiquotePhonePermissions
